



















































































































import {
    defineComponent,
    inject,
    reactive,
    computed,
    ref,
    onMounted,
} from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

export default defineComponent({
    setup(_props, { root }) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const showPanel = ref<boolean>(false)
        onMounted(() => {
            const scrollEventHandler = () => {
                if (!root.$el) {
                    return
                }

                const winHeight = window.innerHeight
                const rect = root.$el.getBoundingClientRect()
                const pos = rect.top
                const height = rect.height

                if (-pos > height) {
                    showPanel.value = false
                } else if (winHeight >= pos) {
                    showPanel.value = true
                } else {
                    showPanel.value = false
                }
                setTimeout(scrollEventHandler, 100)
            }
            root.$nextTick(scrollEventHandler)
        })

        const scrollHandler = (selector) => {
            const target = document.querySelector(selector)

            if (!target) {
                return
            }

            const rect = target.getBoundingClientRect()
            window.scrollTo({
                top: window.pageYOffset + rect.top,
                left: 0,
                behavior: 'smooth',
            })
        }

        const isAddressRequired = computed(() => {
            return (
                inputStore.selectedHowto !== null &&
                inputStore.selectedHowto.has_address == '1'
            )
        })
        const validated = reactive({
            name: computed(() => {
                return validatedStore.name === 1
            }),
            tel: computed(() => {
                return validatedStore.tel === 1
            }),
            email: computed(() => {
                return validatedStore.email === 1
            }),
            zip: computed(() => {
                return !isAddressRequired.value || validatedStore.zip === 1
            }),
            address: computed(() => {
                return !isAddressRequired.value || validatedStore.address === 1
            }),
            howto: computed(() => {
                return formStore.howto.length <= 0 || validatedStore.howto === 1
            }),
            ipad: computed(() => {
                return (
                    formStore.howto.length <= 0 ||
                    formStore.ipad != '1' ||
                    validatedStore.ipad === 1
                )
            }),
            shop: computed(() => {
                return formStore.shops.length <= 0 || validatedStore.shop === 1
            }),
            date: computed(() => {
                return validatedStore.date === 1
            }),
            time: computed(() => {
                return formStore.times.length <= 0 || validatedStore.time === 1
            }),
            question: computed(() => {
                return !Object.keys(validatedStore.question).some(
                    (k) => validatedStore.question[k] === 0
                )
            }),
            privacy: computed(() => {
                return validatedStore.privacy === 1
            }),
            first_time: computed(() => {
                return validatedStore.first_time === 1
            }),
        })

        const remainingNumber = computed(() => {
            return Object.keys(validated).reduce((p, k) => {
                return p + (validated[k] ? 0 : 1)
            }, 0)
        })

        return {
            validatedStore,
            showPanel,
            scrollHandler,
            validated,
            remainingNumber,
        }
    },
})
